import {
  BorderRadius,
  ConfigurationTheme,
  getDefaultConfigurationTheme,
  LogoAlign,
  TextWeight,
  ThemeCode,
} from '@tink/config/src/tinkLinkConfig';

const defaultConfiguration = getDefaultConfigurationTheme(ThemeCode.LIGHT);

export const netflixTheme: ConfigurationTheme = {
  ...defaultConfiguration,
  id: 'netflix-theme-id',
  colors: {
    primaryColor: '#E50914',
    primaryTextColor: '#333333',
    secondaryTextColor: '#8C8C8C',
    buttonBackgroundColor: '#E50914',
    buttonTextColor: '#FFFFFF',
    buttonSecondaryTextColor: '#0071EB',
    backgroundColor: '#FFFFFF',
    tintedBackgroundColor: '#F3F3F3',
    errorTextColor: '#E50914',
    pageBackgroundColor: '#F3F3F3',
    strokeColor: '#ECECEC',
  },

  buttons: {
    textWeight: TextWeight.NORMAL,
    borderRadius: BorderRadius.ROUNDED,
    fullWidth: true,
    textUppercase: false,
    shadow: true,
  },

  header: {
    logoAlign: LogoAlign.LEFT,
    showBackButton: false,
    showCloseButton: false,
  },

  fonts: {
    fontFamily: '"Netflix Sans", Helvetica Neue,Segoe UI,Roboto,Ubuntu,sans-serif',
    provider: 'custom',
    identifier: '',
    sourceUrl: [],
    sourceFont: [],
  },

  typography: {
    h1: {
      fontSize: '32px',
      lineHeight: '40px',
    },
    h2: {
      fontSize: '20px',
      lineHeight: '30px',
    },
    paragraph: {
      fontSize: '16px',
      lineHeight: '24px',
    },
    caption: {
      fontSize: '13px',
      lineHeight: '18px',
    },
  },
};
